import React, { useState } from "react";
import { HashLink as Link } from "react-router-hash-link";
import { Paper, Tab, Tabs } from "@mui/material";
import { navigationExtensionEmotionStyle } from "./navigationExtensionAllDataStyle";
import { ContentContainer } from "../Container/PageContentContainer";
import { userHasOneOfTheseRoles, userHasRole } from "../../services/backofficeUserService";
import { useCurrentUser } from "../../provider/CurrentUserProvider";
import { Roles } from "../../types/BackofficeUser";
import { useLocation } from "react-router-dom";

const NavigationExtensionMyAccount = () => {
  const [topOffset, setTopOffset] = useState(69);
  const currentUser = useCurrentUser();
  const location = useLocation();
  const accountPath = `${location.pathname.split("/mein-konto")[0]}/mein-konto`;
  const isBonusPage = location.pathname === `${accountPath}/faelle-und-bonus`;
  const showBonusTab = currentUser.hasBonusAccount;

  return (
    <Paper
      square
      ref={(el) => {
        if (el) {
          setTopOffset(el.getBoundingClientRect().top);
        }
      }}
      sx={navigationExtensionEmotionStyle.tabs({ top: topOffset })}
    >
      <ContentContainer size={"large"}>
        <Tabs variant={"fullWidth"} scrollButtons="auto" value={isBonusPage && showBonusTab ? "bonus" : false} centered>
          <Tab component={Link} to={`${accountPath}#myData`} label={"Meine Daten"} />
          {userHasRole(currentUser, Roles.external) && <Tab component={Link} to={`${accountPath}#billing`} label={"Abrechnung"} />}
          {userHasOneOfTheseRoles(currentUser, [Roles.external, Roles.lawyer]) && (
            <Tab component={Link} to={`${accountPath}#signature`} label={"Unterschrift"} />
          )}
          {userHasRole(currentUser, Roles.lawyer) && <Tab component={Link} to={`${accountPath}#bea`} label={"beA"} />}
          {!userHasRole(currentUser, Roles.external) && <Tab component={Link} to={`${accountPath}#absence`} label={"Abwesenheit"} />}
          {!userHasRole(currentUser, Roles.external) && (
            <Tab component={Link} to={`${accountPath}#workingHours`} label={"Arbeitszeit"} />
          )}
          {showBonusTab && <Tab component={Link} to={`${accountPath}/faelle-und-bonus`} value="bonus" label="Fälle und Bonus" />}
        </Tabs>
      </ContentContainer>
    </Paper>
  );
};

export default NavigationExtensionMyAccount;
